import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';

const [
  VIEW_APPROVAL_TAXBILL,
  VIEW_APPROVAL_TAXBILL_SUCCESS,
  VIEW_APPROVAL_TAXBILL_FAILURE,
] = createRequestActionTypes('approval/VIEW_APPROVAL_TAXBILL');

export const viewApprovalTaxbill = createAction(
  VIEW_APPROVAL_TAXBILL,
  (id) => id,
);

const viewApprovalTaxbillSaga = createRequestSaga(
  VIEW_APPROVAL_TAXBILL,
  taxbillApi.getTaxbill,
);

//trjUuid
const [
  VIEW_APPROVAL_TAXBILL_BY_TRJID,
  VIEW_APPROVAL_TAXBILL_BY_TRJID_SUCCESS,
  VIEW_APPROVAL_TAXBILL_BY_TRJID_FAILURE,
] = createRequestActionTypes('approval/VIEW_APPROVAL_TAXBILL_BY_TRJID');

export const viewApprovalTaxbillByTrjId = createAction(
  VIEW_APPROVAL_TAXBILL_BY_TRJID,
  (id) => id,
);

const viewApprovalTaxbillByTrjIdSaga = createRequestSaga(
  VIEW_APPROVAL_TAXBILL_BY_TRJID,
  taxbillApi.getIssuedTaxbillsByApproval,
);

const [
  LIST_APPROVAL_BUY_TAXBILLS,
  LIST_APPROVAL_BUY_TAXBILLS_SUCCESS,
  LIST_APPROVAL_BUY_TAXBILLS_FAILURE,
] = createRequestActionTypes('approval/LIST_APPROVAL_BUY_TAXBILLS');

export const listApprovalBuyTaxbills = createAction(
  LIST_APPROVAL_BUY_TAXBILLS,
  (id) => id,
);
const listApprovalBuyTaxbillsSaga = createRequestSaga(
  LIST_APPROVAL_BUY_TAXBILLS,
  taxbillApi.getIssuedBuyTaxbillsByApproval,
);

const [
  LIST_APPROVAL_SALES_TAXBILLS,
  LIST_APPROVAL_SALES_TAXBILLS_SUCCESS,
  LIST_APPROVAL_SALES_TAXBILLS_FAILURE,
] = createRequestActionTypes('approval/LIST_APPROVAL_SALES_TAXBILLS');

export const listApprovalSalesTaxbills = createAction(
  LIST_APPROVAL_SALES_TAXBILLS,
  (id) => id,
);
const listApprovalSalesTaxbillsSaga = createRequestSaga(
  LIST_APPROVAL_SALES_TAXBILLS,
  taxbillApi.getIssuedSalesTaxbillsByApproval,
);

export function* issuedTaxbillsSaga() {
  yield takeLatest(LIST_APPROVAL_BUY_TAXBILLS, listApprovalBuyTaxbillsSaga);
  yield takeLatest(LIST_APPROVAL_SALES_TAXBILLS, listApprovalSalesTaxbillsSaga);
  yield takeLatest(VIEW_APPROVAL_TAXBILL, viewApprovalTaxbillSaga);
  yield takeLatest(
    VIEW_APPROVAL_TAXBILL_BY_TRJID,
    viewApprovalTaxbillByTrjIdSaga,
  );
}

const initialState = {
  taxbill: null,
  roInfo: null,
  buyTaxbills: null,
  salesTaxbills: null,
  error: null,
};

const issueTaxbills = handleActions(
  {
    [VIEW_APPROVAL_TAXBILL_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      taxbill: data.info?.invInfo,
      roInfo: data.info?.roInfo,
    }),
    [VIEW_APPROVAL_TAXBILL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),

    [VIEW_APPROVAL_TAXBILL_BY_TRJID_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      taxbill: data.info,
    }),
    [VIEW_APPROVAL_TAXBILL_BY_TRJID_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),

    [LIST_APPROVAL_BUY_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      buyTaxbills: data.list,
      error: null,
    }),
    [LIST_APPROVAL_BUY_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [LIST_APPROVAL_SALES_TAXBILLS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      salesTaxbills: data.list,
      error: null,
    }),
    [LIST_APPROVAL_SALES_TAXBILLS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
  },
  initialState,
);

export default issueTaxbills;
